<template>
    <div>
        <az-sub-title :title="title ? title : 'Filtros'" :big="!!big">
            <a class="card-link" href="#" @click.prevent="incluir_filtro()" v-if="!viewonly">
                <i class="fas fa-plus mr-2"></i>
                Incluir Filtro
            </a>
        </az-sub-title>
        <div class="mt-2">
            <div class="form-row" v-for="(filtro, ifx) in lista_filtros" :key="ifx">
                <div class="col col-12 col-md-3">
                    <az-input
                        sizing="sm"
                        type="button-group"
                        :edicao="!viewonly"
                        :optionsList="[{id:1,search:'Apenas'}, {id:0,search:'Exceto'}]"
                        :validate="validate"
                        v-model="filtro.fl_regra" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input
                        v-if="filtro.st_tipo_tag"
                        sizing="sm"
                        type="select"
                        optionsMode="json"
                        :optionsList="opcoes"
                        optionsData="id"
                        :validate="validate"
                        required
                        :edicao="false"
                        v-model="filtro.st_tipo_tag">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend" v-if="!viewonly">
                                <button class="btn btn-outline-danger" type="button" @click="remover_filtro(filtro, ifx)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>                                

                    <az-input
                        v-else
                        sizing="sm"
                        type="select"
                        optionsMode="json"
                        :optionsList="opcoes"
                        optionsData="id"
                        :validate="validate"
                        required
                        :edicao="!viewonly && !( filtro.model && filtro.model.search )"
                        v-model="filtro.model_type">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend" v-if="!viewonly">
                                <button class="btn btn-outline-danger" type="button" @click="remover_filtro(filtro, ifx)">
                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>                                
                </div>
                <div class="col col-12 col-md-6">
                    <input type="text" placeholder="..." class="form form-control form-control-sm" disabled v-if="!filtro.model_type && !filtro.st_tipo_tag">

                    <input type="text" placeholder="..." class="form form-control form-control-sm" disabled v-if="!filtro.model_type && filtro.st_tipo_tag && filtro.st_hashtag" v-model="filtro.st_hashtag">

                    <!-- Preenchido -->
                    <az-input
                        sizing="sm"
                        v-else-if="filtro.model && filtro.model.search"
                        placeholder
                        :edicao="false"
                        v-model="filtro.model.search">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="filtro.model_id">
                                <span class="input-group-text">
                                    <small>#{{ filtro.model_id }}</small>
                                </span>
                            </div>
                        </template>
                    </az-input>
                    
                    <!-- Tags -->
                    <az-input
                        sizing="sm"
                        v-else-if="infoFiltro(filtro) && infoFiltro(filtro).tag"
                        placeholder
                        type="select" 
                        optionsMode="aql"
                        :service="infoFiltro(filtro).service" 
                        :optionsName="'filtro-tag-' + filtro.model_type + infoFiltro(filtro).name"
                        :optionsParm="{ ativos: true, agenda: true, filtro: true, tags: true, ...infoFiltro(filtro).parms }"
                        optionsData="id"
                        required 
                        :edicao="!viewonly"
                        v-model="filtro.st_hashtag">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="filtro.st_hashtag">
                                <span class="input-group-text">
                                    <small>{{ filtro.st_hashtag }}</small>
                                </span>
                            </div>
                        </template>
                    </az-input>

                    <!-- Lista AutoComplete -->
                    <az-input
                        sizing="sm"
                        v-else-if="serviceFiltro(filtro.model_type)"
                        placeholder
                        type="autocomplete" 
                        optionsMode="aql"
                        :optionsSync="!infoFiltroModel(filtro.model_type).nosync"
                        :service="serviceFiltro(filtro.model_type)" 
                        :optionsName="'filtro-' + filtro.model_type + infoFiltroModel(filtro.model_type).name"
                        :optionsParm="{ ativos: true, agenda: true, ...infoFiltroModel(filtro.model_type).parms }"
                        required 
                        :edicao="!viewonly"
                        v-model="filtro.model" />
                </div>
            </div>
        </div>

        <div class="row" v-if="false && !viewonly">
            <div class="col col-12">
                <button type="button" class="btn btn-outline-primary btn-sm my-2" @click="incluir_filtro()">
                    <i class="fas fa-plus mr-2"></i>
                    Incluir Filtro
                </button>
            </div>
        </div>

        <div class="row mb-2" v-if="!lista_filtros.length">
            <div class="col col-12">
                <span class="text-muted">
                    Nenhum
                </span>
            </div>
        </div>

        <button type="button" class="btn btn-outline-primary btn-sm" @click="incluir_filtro()" v-if="!viewonly">
            <i class="fas fa-plus"></i>
        </button>
    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
    data() { 
        return { 
            filtros: null, 
        }
    },

    components: { 
        AzInput,
        AzSubTitle,
    },

    props: ['value', 'validate', 'opcoes', 'viewonly', 'title', 'delecao', 'big'],

    computed: { 
        lista_filtros: function () { 

            if ( !this.filtros ) 
                return [];

            return _.orderBy(
                this.filtros.filter(item => !item.excluido),
                filtro => { 
                    return ( filtro.novo || !filtro.model ) ? 'ZZZ' : ( filtro.model_type + '|' + filtro.model.search );
                }
            );
            
        },
    },

    watch: { 
        filtros: {
            handler: function (newValue) { 
                if ( newValue ) { 
                    this.$emit('input', newValue);
                }
            },
            immediate: true,
            deep: true, 
        },

        value: {
            handler: function (newValue) {
                if ( newValue ) { 
                    this.filtros = newValue;
                }
            },
            immediate: true,
        },
    },

    methods: { 
        remover_filtro (filtro, index) { 
            if ( this.delecao ) { 
                this.filtros.splice(index, 1);
            } else { 
                filtro.excluido = true
            }
        },

        infoFiltro(filtro) { 
            if ( !this.opcoes || !filtro ) 
                return null;

            let tipo = filtro.st_tipo_tag ? filtro.st_tipo_tag : filtro.model_type;

            if ( !tipo )
                return null;

            let opcao = this.opcoes.find(item => item.id == tipo);

            return opcao;
        },

        infoFiltroModel(model) { 
            if ( !this.opcoes || !model ) 
                return null;

            let opcao = this.opcoes.find(item => item.id == model);

            return opcao;
        },

        serviceFiltro(model) { 
            let opcao = this.infoFiltroModel(model);
            return opcao ? opcao.service : null;
        },

        incluir_filtro() { 
            this.value.push({ 
                model_type: "",
                model_id: "",
                model: "", 
                service: "", 
                fl_regra: true, 
                excluido: false, 
                novo: true, 
            });
        },
    },
}
</script>